<template>
  <v-dialog persistent :model-value="props.isVisible" max-width="460">
    <v-card>
      <v-card-title>
        {{ t('common.error') }}
      </v-card-title>
      <v-card-text class="text-pre-wrap">
        {{ error.message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <div class="d-flex justify-end w-100">
          <v-btn class="close-button" @click="close">
            {{ buttonText }}
          </v-btn>
        </div>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import type { Error } from '@/types/models/error.d';
import { useErrorStore } from '@/stores/index';
import { computed, type ComputedRef } from 'vue';
import { useI18n } from '#imports';

const props = defineProps<{
  isVisible: boolean;
}>();
const emits = defineEmits<{
  (e: 'redirectClose' | 'close'): void;
}>();

const error: ComputedRef<Error> = computed(() => useErrorStore().error);

const { t } = useI18n();
const buttonText = computed(() =>
  error.value.redirect ? t('button.fc-login') : t('button.close'),
);

const close = () => {
  if (error.value.redirect) {
    emits('redirectClose');
  } else {
    emits('close');
  }
};
</script>

<style scoped lang="scss">
.close-button {
  background-color: #1868c7;
  color: white;
  display: flex;
}
</style>
